export default {
  name: "SidebarBrand",
  
  emits: ["brand-click"],

  props: {
    logo: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "Enter Brand Name"
    },
    subtitle: {
      type: String,
      default: "Enter Brand Subtitle"
    }
  },

  computed: {
    computedLogo() {
      // ensures the logo is always valid, fallback if needed
      if (!this.logo || this.logo === '""') {
        return getComputedStyle(document.documentElement)
          .getPropertyValue("--bolide-logo")
          .replace(/['"]+/g, "");
      }
      return this.logo;
    },

    logoBackgroundImage() {
      const logo = this.computedLogo.trim();
      return logo.startsWith("url(") ? logo : `url(${logo})`;
    }
  }
};
